export const SUPPORT_OBJECT_BY_ID = (id) => `/v2/assist-objects/${id}`;
export const SUPPORT_OBJECTS = `v2/assist-objects`;
export const SUPPORT = `v2/assists`;
export const SUPPORT_BY_ID = (id) => `v2/assists/${id}`;
